module.exports = __webpack_public_path__ + "img/clinic_logo_full_white.41cf6d9f.png";